/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const JobOutcomeNextSnapshot = core.serialization.object({
    snapshotId: core.serialization.string(),
    sheetId: core.serialization.string(),
});
